import request from '@/utils/request'

// 下载
export const donwnloadApi = (params: any) =>
  request({
    url: '/front/download-center/index',
    method: 'post',
    data: params
  })
